
export { useNCWConfirmTransfer } from "/home/runner/work/capsicum/capsicum/libs/features/nc-wallet/web/src/hooks/components/index.ts"